import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft } from '@fortawesome/free-solid-svg-icons/faAnglesLeft';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons/faAnglesRight';

import { PaginationMetaLink } from '../../../models/Paginator';

interface Props {
  links: PaginationMetaLink[];
  currentPage: number;
  onPageChange: (page: number) => void;
  total?: number;
  fromItem?: number;
  toItem?: number;
}

const buttonStyle: React.CSSProperties = {
  paddingLeft: '8px',
  paddingRight: '8px',
  fontSize: '11px',
};

const ImageModalPaginator: React.FC<Props> = ({
  links, currentPage, onPageChange, total, fromItem, toItem,
}) => {
  if (!links || links.length === 0) {
    return null;
  }

  const handlePageClick = (page: number) => {
    if (page >= 1) {
      onPageChange(page);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-between w-100">
      {total !== undefined && fromItem !== undefined && toItem !== undefined && (
        <span style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
          {`${fromItem}-${toItem} of ${total}`}
        </span>
      )}
      <nav aria-label="Image pagination">
        <ul className="pagination pagination-md mb-0">
        {links.map((link) => {
          // Previous button
          if (link.label.includes('Previous')) {
            const isDisabled = !link.url;
            return (
              <li className={`page-item ${isDisabled ? 'disabled' : ''}`} key="prev">
                <button
                  style={buttonStyle}
                  type="button"
                  className="page-link"
                  disabled={isDisabled}
                  onClick={() => {
                    if (!isDisabled && currentPage > 1) {
                      handlePageClick(currentPage - 1);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faAnglesLeft} />
                </button>
              </li>
            );
          }

          // Next button
          if (link.label.includes('Next')) {
            const isDisabled = !link.url;
            return (
              <li className={`page-item ${isDisabled ? 'disabled' : ''}`} key="next">
                <button
                  style={buttonStyle}
                  type="button"
                  className="page-link"
                  disabled={isDisabled}
                  onClick={() => {
                    if (!isDisabled) {
                      handlePageClick(currentPage + 1);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faAnglesRight} />
                </button>
              </li>
            );
          }

          // Page number buttons
          const pageNum = parseInt(link.label, 10);
          const isPageNumber = !isNaN(pageNum);

          if (!isPageNumber) {
            // Ellipsis or other non-numeric labels
            return (
              <li className="page-item disabled" key={`ellipsis-${link.label}`}>
                <span style={buttonStyle} className="page-link">
                  {link.label}
                </span>
              </li>
            );
          }

          return (
            <li className={`page-item ${link.active ? 'active' : ''}`} key={`page-${pageNum}`}>
              <button
                style={buttonStyle}
                type="button"
                className="page-link"
                onClick={() => handlePageClick(pageNum)}
              >
                {link.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
    </div>
  );
};

export default ImageModalPaginator;
